export class DifficultySystem {
  pressure = 1;

  constructor(startPressure = 1) {
    this.pressure = Math.max(0.55, Math.min(1.75, startPressure));
  }

  applyDelta(delta: number) {
    this.pressure = Math.max(0.55, Math.min(1.75, this.pressure + delta));
  }

  grantMercy(amount = 0.12) {
    this.pressure = Math.max(0.55, this.pressure - amount);
  }

  get enemyHpMultiplier() {
    return 0.9 + this.pressure * 0.16;
  }

  get enemySpeedMultiplier() {
    return 0.9 + this.pressure * 0.08;
  }
}
